import React from 'react'
import PropTypes from 'prop-types'

import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'

import './stepper.scss'

export default function Stepper(props) {
  const setStage = (e) => {
    e.preventDefault()

    const step =
      e.target.getAttribute('data-stepper') ||
      e.target.parentNode.getAttribute('data-stepper') ||
      e.target.parentNode.parentNode.getAttribute('data-stepper')

    if (step <= props.max_stage) {
      props.setStage(parseInt(step))
    }
  }

  return (
    <Container>
      <Row>
        {
          props.steps.map((words, i) => {
            if (i <= props.max_stage) {
              return (
                <Col
                  key={`step-${i}`}
                  xs={12 / props.number_of_steps}
                  data-stepper={i}
                  onClick={(e) => setStage(e)}
                  className={
                    i === props.stage
                      ? `d-flex justify-content-center step active step-${i} steps-${props.number_of_steps}`
                      : `d-flex justify-content-center step done step-${i} steps-${props.number_of_steps}`
                  }
                >
                  <div
                    className="d-flex align-items-center"
                  >
                    <i
                      onClick={(e) => setStage(e)}
                      className={
                        (Array.isArray(props.steps[i]) && props.steps[i].length > 1)
                          ? `fa ${props.steps[i][1]}`
                          : ""
                      }
                      style={{padding: '10px'}}
                    />
                    {(Array.isArray(words) && props.steps[i].length > 1)
                      ? words[0]
                      : words
                    }
                  </div>
                </Col>
              )
            } else {
              return (
                <Col
                  key={`step-${i}`}
                  xs={12 / props.number_of_steps}
                  data-stepper={i}
                  onClick={(e) => setStage(e)}
                  className={`d-flex justify-content-center step step-${i} steps-${props.number_of_steps}`}
                >
                  <div className="d-flex align-items-center">
                    <i
                      onClick={(e) => setStage(e)}
                      className={
                        (Array.isArray(props.steps[i]) && props.steps[i].length > 1)
                          ? `fa ${props.steps[i][1]}`
                          : ""
                      }
                      style={{padding: '10px'}}
                    />
                    {(Array.isArray(words) && props.steps[i].length > 1)
                      ? words[0]
                      : words
                    }
                  </div>
                </Col>
              )
            }
          })
        }
      </Row>
    </Container>
  )
}

Stepper.propTypes = {
  steps: PropTypes.array.isRequired,
  number_of_steps: PropTypes.number.isRequired,
  stage: PropTypes.number.isRequired,
  max_stage: PropTypes.number.isRequired,
  setStage: PropTypes.func.isRequired
}